var CgsComponentsModule = /** @class */ (function () {
    function CgsComponentsModule() {
    }
    return CgsComponentsModule;
}());
export { CgsComponentsModule };
